import React from "react";

export default function PageHeader({
  title,
  subtitle,
  actions,
  icon: Icon,
  color = "slate",
}) {
  const variants = {
    blue: {
      icon: "text-blue-600",
      iconBg: "bg-blue-100",
      glow: "from-blue-500/15 to-cyan-500/5",
    },
    green: {
      icon: "text-green-600",
      iconBg: "bg-green-100",
      glow: "from-green-500/15 to-emerald-500/5",
    },
    orange: {
      icon: "text-orange-600",
      iconBg: "bg-orange-100",
      glow: "from-orange-500/15 to-amber-500/5",
    },
    purple: {
      icon: "text-purple-600",
      iconBg: "bg-purple-100",
      glow: "from-purple-500/15 to-fuchsia-500/5",
    },
    red: {
      icon: "text-red-600",
      iconBg: "bg-red-100",
      glow: "from-red-500/15 to-pink-500/5",
    },
    slate: {
      icon: "text-slate-700",
      iconBg: "bg-slate-100",
      glow: "from-slate-500/10 to-slate-200/5",
    },
  };

  const style = variants[color] || variants.slate;

  return (
    <header className="sticky top-0 z-40 border-b border-gray-200/70 bg-white/85 backdrop-blur-xl">
      <div className="relative overflow-hidden px-6 py-5">
        {/* Subtelny gradient w tle */}
        <div
          className={`absolute inset-0 bg-gradient-to-r ${style.glow} pointer-events-none`}
        />

        <div className="relative flex items-center justify-between gap-6">
          <div className="flex min-w-0 items-center gap-4">
            {Icon && (
              <div
                className={`flex h-14 w-14 items-center justify-center rounded-2xl ${style.iconBg} shadow-sm`}
              >
                <Icon className={`h-7 w-7 ${style.icon}`} />
              </div>
            )}

            <div className="min-w-0">
              <h1 className="truncate text-2xl font-bold tracking-tight text-slate-900">
                {title}
              </h1>

              {subtitle && (
                <p className="mt-1 text-sm text-slate-500">
                  {subtitle}
                </p>
              )}
            </div>
          </div>

          {actions && (
            <div className="flex flex-shrink-0 items-center gap-3">
              {actions}
            </div>
          )}
        </div>
      </div>
    </header>
  );
}